var _excluded = ["sys", "__typename"],
  _excluded2 = ["components", "componentsCollection"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable no-console, react/prop-types, import/no-cycle */
import React from 'react';
import camelCase from 'lodash/camelCase';
import { renderContentType as defaultRenderContentType } from './content-type-renderers';
export var renderContentfulComponent = function () {
  var _sys$contentType, _sys$contentType$sys;
  var {
    contentfulComponent = {},
    entry = {},
    options = {},
    parents = []
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var {
      sys,
      __typename
    } = contentfulComponent,
    componentProperties = _objectWithoutProperties(contentfulComponent, _excluded);
  var fields = componentProperties.fields ? componentProperties.fields : componentProperties;
  var contentType = (sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : (_sys$contentType$sys = _sys$contentType.sys) === null || _sys$contentType$sys === void 0 ? void 0 : _sys$contentType$sys.id) || camelCase(__typename);
  if (!contentType) {
    console.error("Error rendering Contentful component: no contentType found");
    return null;
  }
  var renderContentType = _objectSpread(_objectSpread({}, defaultRenderContentType), options.renderContentType || {})[contentType];
  if (!renderContentType) {
    return null;
  }
  var {
      components,
      componentsCollection
    } = fields,
    data = _objectWithoutProperties(fields, _excluded2);
  data.entryId = sys.id;

  // If field is a Reference to nested components, call renderContentfulComponent() on the nested components
  var childComponents = components || (componentsCollection === null || componentsCollection === void 0 ? void 0 : componentsCollection.items);
  var children = null;
  if (
  // render children by default, but not if option is provided to disable
  (options.renderChildren === undefined || options.renderChildren) && Array.isArray(childComponents)) {
    children = childComponents.map(childComponent => renderContentfulComponent({
      entry,
      contentfulComponent: childComponent,
      options,
      parents: [...parents, contentfulComponent]
    }));
  }

  // Get the output for a content type
  var element = renderContentType({
    children,
    contentfulComponent,
    data,
    entry,
    options,
    parents
  });

  // If output is null (e.g., filtered out based on a tag) return null
  if (!element) return null;
  var transformedElement = options.transformElement ? options.transformElement({
    element,
    contentType,
    contentfulComponent,
    entry,
    parents
  }) : element;

  // Wrap in fragment with key added
  return /*#__PURE__*/React.cloneElement(transformedElement, {
    key: sys.id
  });
};
export var renderContentfulPage = function () {
  var _entry$fields, _entry$fields$compone;
  var {
    entry = {},
    options = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!(entry !== null && entry !== void 0 && (_entry$fields = entry.fields) !== null && _entry$fields !== void 0 && (_entry$fields$compone = _entry$fields.components) !== null && _entry$fields$compone !== void 0 && _entry$fields$compone.length)) {
    console.error('Error rendering Contentful entry: no components found');
    return null;
  }
  return entry.fields.components.map(contentfulComponent => renderContentfulComponent({
    entry,
    contentfulComponent,
    options
  }));
};